module.exports = __webpack_public_path__ + "img/319.7ab87d49.png";